export const summaryRows: string[] = [
  'Volume 1 — Data Center Fundamentals: Architecture, Redundancy & Availability',
  'Volume 2 — Critical Power Distribution: From Utility to Rack',
  'Volume 3 — UPS Systems & Battery Energy Storage',
  'Volume 4 — Standby Power: Generators, Transfer Systems & Fuel',
  'Volume 5 — Cooling & Mechanical Systems: From Air to Liquid',
  'Volume 6 — Operations, Maintenance, Commissioning & Electrical Safety',
  'Bonus 1 — Career Transition Roadmap: From Electrician or HVAC Technician to Data Center Professional',
  'Bonus 2 — Data Center Technical Glossary',
  'Bonus 3 — Quick Reference Cards: Critical Systems at a Glance',
  'Bonus 4 — Technical Interview Preparation Guide',
  'Bonus 5 — Preventive Maintenance Checklists for Critical Systems',
  '7-day money-back guarantee',
  'Instant access',
];
